import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

const guideArticles = [
  {
    title: 'Co to jest Kakobuy Sheet?',
    slug: '/co-to-jest-kakobuy-sheet',
    icon: 'ri-book-read-line',
    desc: 'Kompletny przewodnik 2026',
  },
];

export default function Navbar() {
  const [categoryOpen, setCategoryOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const [mobileGuideOpen, setMobileGuideOpen] = useState(false);
  const categoryRef = useRef<HTMLDivElement>(null);
  const guideRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (categoryRef.current && !categoryRef.current.contains(e.target as Node)) {
        setCategoryOpen(false);
      }
      if (guideRef.current && !guideRef.current.contains(e.target as Node)) {
        setGuideOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
              <i className="ri-search-line text-white text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-900 tracking-tight whitespace-nowrap">
              Kakobuy Finds
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="flex items-center gap-1.5 text-[15px] font-medium text-foreground-700 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
              <i className="ri-home-4-line text-base"></i>
              Strona Główna
            </Link>

            <div className="relative" ref={categoryRef}>
              <button
                onClick={() => { setCategoryOpen(!categoryOpen); setGuideOpen(false); }}
                className="flex items-center gap-1.5 text-[15px] font-medium text-foreground-700 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apps-2-line text-base text-primary-500"></i>
                Kategorie
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {categoryOpen && (
                <div className="absolute top-full mt-3 left-1/2 -translate-x-1/2 bg-white rounded-2xl shadow-lg border border-foreground-200/20 py-3 min-w-[240px] z-50">
                  <div className="max-h-[400px] overflow-y-auto px-1">
                    {categories.map((cat) => (
                      <a
                        key={cat.nameEn}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-5 py-3 text-[14px] text-foreground-700 hover:bg-primary-50 hover:text-primary-700 rounded-xl transition-all duration-150 whitespace-nowrap"
                        onClick={() => setCategoryOpen(false)}
                      >
                        <span className="w-8 h-8 flex items-center justify-center">
                          <i className={`${cat.icon} text-base text-foreground-400`}></i>
                        </span>
                        {cat.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="relative" ref={guideRef}>
              <button
                onClick={() => { setGuideOpen(!guideOpen); setCategoryOpen(false); }}
                className="flex items-center gap-1.5 text-[15px] font-medium text-foreground-700 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-guide-line text-base text-primary-500"></i>
                Poradnik Zakupowy
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${guideOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {guideOpen && (
                <div className="absolute top-full mt-3 left-1/2 -translate-x-1/2 bg-white rounded-2xl shadow-lg border border-foreground-200/20 py-3 min-w-[280px] z-50">
                  <div className="px-4 pb-2 mb-1 border-b border-foreground-100/60">
                    <p className="text-[11px] font-semibold text-foreground-400 uppercase tracking-[0.05em] whitespace-nowrap">
                      Artykuły SEO
                    </p>
                  </div>
                  <div className="px-1">
                    {guideArticles.map((article) => (
                      <Link
                        key={article.slug}
                        to={article.slug}
                        className="flex items-start gap-3 px-4 py-3 text-[14px] text-foreground-700 hover:bg-primary-50 rounded-xl transition-all duration-150"
                        onClick={() => setGuideOpen(false)}
                      >
                        <span className="w-8 h-8 rounded-lg bg-foreground-50 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className={`${article.icon} text-base text-foreground-400`}></i>
                        </span>
                        <div>
                          <p className="font-semibold text-foreground-900 whitespace-nowrap">{article.title}</p>
                          <p className="text-[12px] text-foreground-400 mt-0.5">{article.desc}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="ml-2 px-5 py-2.5 bg-foreground-900 text-white text-[14px] font-semibold rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Kakobuy Sheet
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-5 border-t border-foreground-100 max-h-[calc(100vh-72px)] overflow-y-auto">
            <div className="flex flex-col gap-1 pt-4">
              <Link to="/" className="flex items-center gap-2 px-4 py-3 text-[15px] font-medium text-foreground-700 hover:bg-foreground-50 rounded-xl whitespace-nowrap" onClick={() => setMobileOpen(false)}>
                <i className="ri-home-4-line text-lg text-primary-500"></i>
                Strona Główna
              </Link>

              <button
                onClick={() => setMobileCatOpen(!mobileCatOpen)}
                className="flex items-center justify-between w-full px-4 py-3 text-[15px] font-medium text-foreground-700 hover:bg-foreground-50 rounded-xl whitespace-nowrap cursor-pointer"
              >
                <span className="flex items-center gap-2">
                  <i className="ri-apps-2-line text-lg text-primary-500"></i>
                  Kategorie
                </span>
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {mobileCatOpen && (
                <div className="px-3 pb-2">
                  <div className="grid grid-cols-2 gap-1.5">
                    {categories.map((cat) => (
                      <a
                        key={cat.nameEn}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-2 px-3 py-3 text-[13px] text-foreground-600 hover:bg-primary-50 hover:text-primary-700 rounded-xl transition-colors cursor-pointer"
                        onClick={() => setMobileOpen(false)}
                      >
                        <span className="w-7 h-7 rounded-lg bg-foreground-50 flex items-center justify-center flex-shrink-0">
                          <i className={`${cat.icon} text-sm text-foreground-500`}></i>
                        </span>
                        <span className="whitespace-nowrap text-[13px] leading-tight">{cat.name}</span>
                      </a>
                    ))}
                  </div>
                </div>
              )}

              <button
                onClick={() => setMobileGuideOpen(!mobileGuideOpen)}
                className="flex items-center justify-between w-full px-4 py-3 text-[15px] font-medium text-foreground-700 hover:bg-foreground-50 rounded-xl whitespace-nowrap cursor-pointer"
              >
                <span className="flex items-center gap-2">
                  <i className="ri-guide-line text-lg text-primary-500"></i>
                  Poradnik Zakupowy
                </span>
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${mobileGuideOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {mobileGuideOpen && (
                <div className="px-3 pb-1">
                  {guideArticles.map((article) => (
                    <Link
                      key={article.slug}
                      to={article.slug}
                      className="flex items-center gap-3 px-4 py-3 text-[14px] text-foreground-700 hover:bg-primary-50 rounded-xl transition-colors"
                      onClick={() => setMobileOpen(false)}
                    >
                      <span className="w-7 h-7 rounded-lg bg-foreground-50 flex items-center justify-center">
                        <i className={`${article.icon} text-sm text-foreground-500`}></i>
                      </span>
                      <span className="text-[14px] whitespace-nowrap">{article.title}</span>
                    </Link>
                  ))}
                </div>
              )}

              <div className="px-4 pt-3">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block w-full text-center px-5 py-3 bg-foreground-900 text-white text-[14px] font-semibold rounded-full whitespace-nowrap"
                  onClick={() => setMobileOpen(false)}
                >
                  <i className="ri-external-link-line mr-1.5"></i>
                  Kakobuy Sheet
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}